module.exports = __webpack_public_path__ + "img/bitcoin-btc-gold.dd035820.svg";